import React from 'react';
import NumberCard from '../NumberCard';

import classes from './classes.module.css';

export default class SimpleCountDownTimer extends React.PureComponent {

    interval = null;

    state = {
        current: new Date().getTime(),
    };

    startTimer = () => this.interval = setInterval(() => this.setState({ current: new Date().getTime() }), 1000);

    stopTimer = () => this.interval && clearInterval(this.interval);

    checkIfEndTimeReached = () => Math.abs(this.state.current - this.props.targetEpoch) < 1000
        || this.state.current > this.props.targetEpoch;

    componentDidMount = () => this.startTimer();

    componentDidUpdate = () => this.checkIfEndTimeReached() && this.stopTimer();

    componentWillUnmount = () => this.stopTimer();

    getDiffValues = (epoch1, epoch2) => {
        if (epoch1 > epoch2) return { d: 0, h: 0, m: 0, s: 0 };

        const diff = Math.abs(epoch1 - epoch2);
        const d = Math.floor(diff / (1000 * 60 * 60 * 24)), daysEpoch = d * 24 * 60 * 60 * 1000;
        const h = Math.floor((diff - daysEpoch) / (1000 * 60 * 60)), hoursEpoch = h * 60 * 60 * 1000;
        const m = Math.floor((diff - daysEpoch - hoursEpoch) / (1000 * 60)), minsEpoch = m * 60 * 1000;
        const s = Math.floor((diff - daysEpoch - hoursEpoch - minsEpoch) / (1000));
        return { d, h, m, s };
    };

    render = () => {
        const { className, style, targetEpoch } = this.props;
        const { current } = this.state;

        const currentDiffValues = this.getDiffValues(current, targetEpoch);

        return <div className={`${classes.container} ${className || ''}`} style={style}>
            <div className={classes.number}>
                <NumberCard number={currentDiffValues.d} style={this.props.boxStyle} />
                <div style={{ fontSize: this.props.subTextSize }} className={classes.subText}>DAYS</div>
            </div>
            <div className={classes.space} />
            <div className={classes.number}>
                <NumberCard number={currentDiffValues.h} style={this.props.boxStyle} />
                <div style={{ fontSize: this.props.subTextSize }} className={classes.subText}>HOURS</div>
            </div>
            <div className={classes.space} />
            <div className={classes.number}>
                <NumberCard number={currentDiffValues.m} style={this.props.boxStyle} />
                <div style={{ fontSize: this.props.subTextSize }} className={classes.subText}>MINUTES</div>
            </div>
            <div className={classes.space} />
            <div className={classes.number}>
                <NumberCard number={currentDiffValues.s} style={this.props.boxStyle} />
                <div style={{ fontSize: this.props.subTextSize }} className={classes.subText}>SECONDS</div>
            </div>
        </div>;
    }

}

SimpleCountDownTimer.defaultProps = {
    targetEpoch: new Date().getTime() + 100000,
    boxStyle: {
        height: 56,
        width: 56,
        fontSize: 24,
    },
    subTextSize: 10,
};